import { IFeedback } from '../types';

export default class FeedbackState {
  feedback: IFeedback[] = [];
}
